export default __webpack_public_path__ + "static/media/T.fb660313.svg";